import React from 'react'

const History = () => {
    return (
        <div className="container history">
            <div className="row">
                <div className="col-12">


                    <div className='historySection'>
                        <h3>History of Chennai Nanabargal Nala Mandram</h3>

                        <p className='historyPara'> &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Society Scientist Thir.T.V. Kabali. M.A. Founder of Chennai Nanbargal Nala Mandram. Organize a committee with Thiru.A.K.Natarajan founder of Social Service Society
                            (SSS), Govt. Officers in each Department and our Society friends to conduct a meeting and they give suggestion, we would help our society friends and family members in Chennai area
                            to give awareness for Development in Education for that all are combinedly joined to take decision to start a Registered Welfare Society in the name of <b>“Chennai Nanbargal Nala Mandram.”</b></p>
                        <br /> <h3>CHENNAI NANBARGAL NALA MANDRAM - Starting Memories:</h3>
                        <ul><li>Thiru.T. Arunachalam. M.A.B.L., Engr. Worked as a superindent in Highways Department.</li>
                            <li>Thiru.K. Rathinam and Thiru.S. Durai worked in Postal Department.</li>
                            <li>Thiru. Durai-Ramanujam worked at Corporation of Chennai.</li>
                            <li>Thiru.T.R. Manoharan. B.A. worked at Metro water, Corporation of Chennai.</li>
                            <li>Thiru.M.R. Balakrishnan worked at Co-operative Bank, Indian Railways.</li>
                            <li>Thiru.P. Ramasamy worked at Madras University.</li>
                            <li>Thiru.K. Radhakrishnan. B.Com., B.L. worked at Madras University and other Govt-Officers are consult with each other to help and create awareness to people in our society. Thirukkural Munusamy and Thiru.J. Ambasankar. I.A.S suggest to Register our Society at Register of Society, Govt. of Tamil Nadu in the name of “Nanbargal Nala Mandram” on 1985.</li>
                        </ul>

                        <p>As per Govt. of Tamil Nadu Society Act 27/1975 Part (10), <b> Registered our Society in the name of “Chennai Nanbargal Nala Mandram” at Register of Society, North Chennai Office on 07.05.1985 (Register No.75/1985 at 16.05.1985). </b></p>


                        <p>After getting Registered Number, Elected Office Bearers Take Over Charge (TOC) as per Bye-Law are eligible in one year only.</p>

                        <b>1985-1986 – The first TOC of Persident, Secretary & Treasurer given Below.:</b>
                        <br />
                        <br />
                        <ol>
                            <li>President   -   Thiru.T.P. Kandasamy. B.E.</li>
                            <li>Secretary	-	Thiru.K. Rathinam</li>
                            <li>Treasurer	-	Thiru.C. Chithambaram</li>
                        </ol>
                        <p>Following Presidents are Thiru.K. Ponnusamy. I.A.S., Thiru.M. Gopalakrishnan. I.A.S., Thiru.M. Aadhimoolam. I.A.S. They are doing excellent service with their period to our society peoples.</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default History
